"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsMulti = void 0;
var react_1 = __importStar(require("react"));
var OptionsShell_1 = require("../OptionsShell");
var colors_1 = require("../../../../themes/colors");
var useSetYOrientation_1 = require("../../utils/useSetYOrientation");
var useKeyboardControl_1 = require("../../utils/useKeyboardControl");
var NoOptionResultsComp_1 = require("../NoOptionResultsComp");
var OptionContent_1 = require("../OptionContent");
var styled_1 = require("../OptionsSingle/styled");
var CheckboxButton_1 = require("../../../RadioAndCheckbox/comps/CheckboxList/comps/CheckboxButton");
var Divider_1 = require("../../../Divider");
var TextInputs_1 = require("../../../TextInputs");
var Typo_1 = require("../../../Typo");
var TextLoader_1 = require("../../../LoadersAndProgress/TextLoader");
var greyColor40 = colors_1.colors.greyColor40, white = colors_1.colors.white;
var CheckboxButtonShell = function (_a) {
    var children = _a.children, isSelected = _a.isSelected, invert = _a.invert;
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            alignItems: "center",
            position: "relative",
        } },
        react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: "OKE-Dropdown__checkboxClickArea" }),
            react_1.default.createElement(CheckboxButton_1.CheckboxButton, { invert: invert, isSelected: isSelected, className: "OKE-Dropdown__checkboxClickArea-box" })),
        children));
};
var OptionsMulti = function (_a) {
    var 
    //from root
    lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, optionsAnchor = _a.optionsAnchor, value = _a.value, id = _a.id, optionsClassName = _a.optionsClassName, 
    //from Dropdown
    relativeToRef = _a.relativeToRef, //the element that this lightbox is being rendered against. i.e top or bottom
    showOptions = _a.showOptions, handleHideOptions = _a.handleHideOptions, handleSelect = _a.handleSelect, options = _a.options, isSearchable = _a.isSearchable, label = _a.label, optionsModalLabel = _a.optionsModalLabel, //label is just a fallback for optionsModalLabel. Don't know why both are needed
    searchString = _a.searchString, setSearchString = _a.setSearchString, SelectComp = _a.SelectComp, // for mobile
    isTagsStyle = _a.isTagsStyle, genCreateTagButton = _a.genCreateTagButton, invert = _a.invert, setFocusSelectTagsInput = _a.setFocusSelectTagsInput, popOutOfOverflowHiddenParent = _a.popOutOfOverflowHiddenParent, S = _a.S, searchbarPlaceholder = _a.searchbarPlaceholder, alignDropdown = _a.alignDropdown;
    //INIT ORIENTATION STATE AND CUSTOM HOOK
    var optionsRef = (0, react_1.useRef)(null);
    var yOrientation = (0, useSetYOrientation_1.useSetYOrientation)({
        showOptions: showOptions,
        optionsRef: optionsRef,
        relativeToRef: relativeToRef,
    }).yOrientation;
    //RESET SEARCHSTRING WHEN OPTIONS ARE CLOSED
    (0, react_1.useEffect)(function () {
        if (!showOptions && !!searchString === true)
            setSearchString("");
    }, [showOptions]);
    var selectedOptions = (0, react_1.useMemo)(function () {
        return value || [];
        //we need this to update on optionsProp, cuz when tag is created inTagsInputMulti
        //opsProp changes.
        //if we use value as dep, then this will update on every onChange, which we dont want.
    }, [
        // showOptions,
        JSON.stringify(options),
        value,
    ]);
    var _b = (0, useKeyboardControl_1.useKeyboardControl)({
        showOptions: showOptions,
        optionsWrapperRef: optionsRef,
        handleHideOptions: handleHideOptions,
        handleSelect: handleSelect,
        options: options,
        searchString: searchString,
        id: id,
    }), scrollFocussedOpIntoView = _b.scrollFocussedOpIntoView, focussedOp = _b.focussedOp;
    var opIsSelected = function (thisOpData) {
        return value === null || value === void 0 ? void 0 : value.some(function (d) { return d.value === thisOpData.value; });
    };
    var _c = (0, react_1.useState)(true), searchBarFocus = _c[0], setSearchBarFocus = _c[1];
    (0, react_1.useEffect)(function () {
        setSearchBarFocus(showOptions);
    }, [showOptions]);
    var createOption = function (d) {
        return isTagsStyle ? (react_1.default.createElement(OptionContent_1.OptionContent, { option: d, optionsClassName: optionsClassName, invert: invert })) : (react_1.default.createElement(CheckboxButtonShell, { invert: invert, isSelected: opIsSelected(d) },
            react_1.default.createElement(OptionContent_1.OptionContent, { option: d, optionsClassName: optionsClassName, invert: invert, S: S })));
    };
    var createSelectedOptions = function () {
        return (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 && (react_1.default.createElement("div", { style: {
                borderBottom: "1px solid ".concat(greyColor40),
            } },
            react_1.default.createElement(Typo_1.LABEL, { invert: invert, style: { padding: "2rem", paddingBottom: 0 }, color: colors_1.colors.greyColor70 }, "selected"),
            selectedOptions.map(function (d) {
                return (react_1.default.createElement(styled_1.StyledOption, { invert: invert, key: d.value, isSelected: opIsSelected(d), S: S, onClick: function (e) {
                        if (!d.loading) {
                            handleSelect(d);
                            setSearchString("");
                            setSearchBarFocus(true); //refocus on searchbar after select
                        }
                    }, 
                    //this is important cuz if we dont, then the option will have the light blue background of the 'selected' state
                    //is a bit hacky, but will do for now.
                    style: { backgroundColor: invert ? colors_1.colors.greyColor90 : white } }, createOption(d)));
            })));
    };
    var genSearchBar = function () { return (react_1.default.createElement("div", { style: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            background: invert ? colors_1.colors.greyColor90 : colors_1.colors.white,
        } },
        react_1.default.createElement("div", { style: { padding: "1rem" }, onBlur: function () { return setSearchBarFocus(false); }, tabIndex: 0 },
            react_1.default.createElement(TextInputs_1.TextInput, { placeholder: searchbarPlaceholder, forceFocus: searchBarFocus, invert: invert, type: "text", icon: "MagnifyingGlass", value: searchString, onChange: function (k, v) { return setSearchString(v); }, S: S })),
        react_1.default.createElement(Divider_1.Divider, { invert: invert }))); };
    console.log({ options: options });
    return (react_1.default.createElement(OptionsShell_1.OptionsShell, { ref: optionsRef, yOrientation: yOrientation, lightboxHeight: lightboxHeight, lightboxStyle: lightboxStyle, options: options, optionsAnchor: optionsAnchor, showOptions: showOptions, handleHideOptions: handleHideOptions, SelectComp: SelectComp, label: label, optionsModalLabel: optionsModalLabel, invert: invert, showDoneButton: true, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent, relativeToRef: relativeToRef, S: S, alignDropdown: alignDropdown },
        isSearchable && genSearchBar(),
        !isTagsStyle && createSelectedOptions(),
        options.length === 0 ? (react_1.default.createElement(NoOptionResultsComp_1.NoOptionResultsComp, { S: S })) : (options.map(function (d, i) {
            return (react_1.default.createElement(styled_1.StyledOption, { key: d.value, invert: invert, isSelected: opIsSelected(d), isFocussed: focussedOp === i, className: "OKE-Dropdown__option", ref: function (el) {
                    return focussedOp === i && el && scrollFocussedOpIntoView(el);
                }, onClick: function (e) {
                    if (!d.loading) {
                        handleSelect(d);
                        setSearchBarFocus(true);
                        setSearchString("");
                        setFocusSelectTagsInput && setFocusSelectTagsInput(true);
                    }
                }, S: S }, d.loading ? (react_1.default.createElement(TextLoader_1.TextLoader, { style: { width: "8rem", height: "1.5rem" } })) : (createOption(d))));
        })),
        genCreateTagButton && genCreateTagButton(options)));
};
exports.OptionsMulti = OptionsMulti;
